import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);

// hero slider block
if (document.querySelector('.hero-slider')) {
	const heroSliderBlock = new Swiper('.hero-slider .swiper', {
		modules: [Autoplay, Pagination],
		spaceBetween: 0,
		speed: 1000,
		threshold: 10,
		autoHeight: true,
		autoplay: {
			delay: 8000,
			disableOnInteraction: false,
		},
		pagination: {
			el: document.querySelector('.hero-slider .swiper-pagination'),
			type: 'bullets',
			clickable: true,
		},
		on: {
			slideChangeTransitionStart: function () {
				gsap.timeline({
					defaults: {
						duration: 0.75,
						ease: 'power2.out',
					}
				})
				.to(document.querySelectorAll('.hero-slider .anim-nest-circle-secondary'), { scale: 0 })
				.to(document.querySelectorAll('.hero-slider .anim-circle-primary'), { scale: 0 }, '<=0.1')
				.to(document.querySelectorAll('.hero-slider .anim-nest-circle-secondary'), { scale: 1 })
				.to(document.querySelectorAll('.hero-slider .anim-circle-primary'), { scale: 1 }, '<=0.1');
			},
		}
	});
}

// animation for shapes on the hero
const heroSliderShapesAnim = document.querySelector('.hero-slider-shapes-anim');
if (heroSliderShapesAnim) {
	// add shapes to slides
	let heroSlides = gsap.utils.toArray('.hero-slider-shapes-anim .swiper-slide');
	heroSlides.forEach((slide, index) => {
		let circle = document.createElement('div'),
			nestCircle = document.createElement('div');
			nestCircle.appendChild(document.createElement('div'));
		circle.className = 'anim-circle-primary';
		nestCircle.className = 'anim-nest-circle-secondary';
		slide.querySelector('.hero-slide__image').appendChild(circle);
		slide.querySelector('.hero-slide__image').appendChild(nestCircle);
		// animate shapes on load
		gsap.fromTo(nestCircle, { scale: 0 }, { scale: 1, ease: 'power2.out', duration: 1.5 });
		gsap.fromTo(circle, { scale: 0 }, { scale: 1, ease: 'power2.out', duration: 1.5 }, '<=0.1');
	});
}

const coreServicesBlock = document.querySelector('.core-services');
if (coreServicesBlock) {
	let coreServicesBlocktl = gsap.timeline({
		scrollTrigger: {
			trigger: coreServicesBlock.querySelector('.core-services__rating'),
			start: 'top 95%',
			once: true,
			// markers: true,
			onEnter: () => {
				setTimeout(() => {
					counter(coreServicesBlock.querySelector('.core-services__rating .count-up'));
				}, 500);
			},
		},
	})
	.fromTo(coreServicesBlock.querySelector('.core-services__rating'), { scale: 0 }, { scale: 1, ease: 'power2.out', duration: 1.5 })
	.fromTo(coreServicesBlock.querySelector('.core-services__rating .rocket-icon'), { scale: 0, opacity: 1 }, { scale: 1, ease: 'power2.out', duration: 1.5 }, 0.5)
	.fromTo(coreServicesBlock.querySelector('.core-services__rating-inner'), { '--ratingClip': '0%' }, { '--ratingClip': '60%', ease: 'power2.out', duration: 0.5 }, 0.5)
	.fromTo(coreServicesBlock.querySelector('.core-services__cards-wrapper .circle-icon'), { scale: 0 }, { scale: 1, ease: 'power2.out', duration: 1.5 }, 0.5);
}

let animDur = 1500;
let frameDur = 1000 / 60;
let totalFrames = Math.round(animDur / frameDur);
let easeOutQuad = (t) => t * (2 - t);

function counter(number) {
	let frame = 0;
	let countTo = number.dataset.countTo;

	let countUp = setInterval(() => {
		frame++;

		const progress = easeOutQuad(frame / totalFrames);
		const current = Math.round(countTo * progress);

		if (number.dataset.countTo !== current) {
			number.innerHTML = current;
		}

		if (frame == totalFrames) {
			clearInterval(countUp);
		}
	}, frameDur);
}

const coreServicesList = document.querySelectorAll('.services-list .list-item');
if (coreServicesList) {
	coreServicesList.forEach((item) => {
		if (!window.matchMedia('(pointer: coarse)').matches) {
			item.addEventListener('mouseenter', () => {
				item.classList.add('active');
				slideDown(item.querySelector('.list-item__excerpt'));
				slideDown(item.querySelector('.list-item__content'));
			});
			item.addEventListener('mouseleave', () => {
				item.classList.remove('active');
				slideUp(item.querySelector('.list-item__excerpt'));
				slideUp(item.querySelector('.list-item__content'));
			});
		}
		item.querySelector('.list-item__trigger').addEventListener('click', () => {
			item.classList.toggle('active');
			if (item.classList.contains('active')) {
				slideDown(item.querySelector('.list-item__excerpt'));
				slideDown(item.querySelector('.list-item__content'));
			} else {
				slideUp(item.querySelector('.list-item__excerpt'));
				slideUp(item.querySelector('.list-item__content'));
			}
		});
	});
}

function slideDown(el) {
	el.style.height = 'auto';
	let getHeight = el.offsetHeight;
	el.removeAttribute('style');
	gsap.set(el, { height: 0 });
	gsap.to(el, { height: getHeight, duration: 0.4 });
	el.classList.add('active');
}

function slideUp(el) {
	gsap.to(el, { height: 0, duration: 0.4 });
	el.classList.remove('active');
}

// init insights slider
const insightsSlider = new Swiper('.insights__slider .swiper', {
	modules: [Navigation, Pagination],
	autoHeight: true,
	slidesPerView: 1,
	spaceBetween: 2,
	loop: true,
	loopAdditionalSlides: 2,
	navigation: {
		nextEl: '.insights__slider-nav .swiper__next',
		prevEl: '.insights__slider-nav .swiper__prev',
	},
	pagination: {
		el: document.querySelector('.insights__slider .swiper-pagination'),
		type: 'progressbar',
	},
	breakpoints: {
		600: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 2,
		},
		1280: {
			slidesPerView: 3,
		}
	}
});
